import * as THREE from 'three';

class TextureManager {
    constructor () {
        this.textureLoader = new THREE.TextureLoader();
        this.textures = {};
    }

    async loadTexture(name, url) {
        if (this.textures[name]) {
            return this.textures[name];
        }
        return new Promise((resolve, reject) => {
            this.textureLoader.load(
                url,
                (texture) => {
                    this.textures[name] = texture;
                    resolve(texture);
                },
                undefined,
                (err) => reject(err)
            );
        });
    }

    async loadAllTextures() {
        await Promise.all([
            this.loadTexture('laserColor', './textures/effects/laser.png'),
            this.loadTexture('explosion', './textures/effects/explosion.png'),
        ]);
    }
    getTexture(name){
        return this.textures[name];
    }
}

export const textureManager = new TextureManager();